import React, { useEffect, useState } from "react";
import * as api from "../../api/index.js";

import {
  Button,
  Typography,
  Card,
  CardContent,
  Box,
  IconButton,
  Container,
  CircularProgress,
  Fade,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  MenuItem,
  TablePagination,
} from "@material-ui/core";

import RefreshIcon from "@material-ui/icons/Refresh";

// export default function QrScanReport() {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // Filters
//   const [station, setStation] = useState("");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [invoiceNumber, setInvoiceNumber] = useState("");

//   /* ------------------ Dummy Data (TEMP) ------------------ */
//   const dummyRows = [
//     {
//       _id: "1",
//       invoiceNumber: "INV-001",
//       station: "Station1",
//       scanStatus: "SUCCESS",
//       scannedAt: "2025-12-17T10:20:30.000Z",
//       scannedBy: { name: "Staff A" },
//     },
//     {
//       _id: "2",
//       invoiceNumber: "INV-002",
//       station: "Station2",
//       scanStatus: "REJECTED",
//       rejectReason: "QR already scanned",
//       scannedAt: "2025-12-17T11:05:10.000Z",
//       scannedBy: { name: "Staff B" },
//     },
//   ];

//   /* ------------------ Fetch Report ------------------ */
//   const fetchReport = async () => {
//     try {
//       setLoading(true);

//       const { data } = await api.fetchQrScanReport({
//         station,
//         startDate,
//         endDate,
//         invoiceNumber,
//       });

//       // ✅ Ensure rows is always an array
//       if (Array.isArray(data) && data.length > 0) {
//         setRows(data);
//       } else {
//         setRows(dummyRows); // fallback until backend has data
//       }
//     } catch (error) {
//       console.error("Failed to load QR scan report", error);
//       setRows(dummyRows); // fallback on error
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchReport();
//     // eslint-disable-next-line
//   }, []);

//   return (
//     <Box>
//       <Container maxWidth="lg">
//         <Fade in timeout={600}>
//           <Card>
//             <CardContent>
//               {/* ---------------- Header ---------------- */}
//               <Box
//                 display="flex"
//                 justifyContent="space-between"
//                 alignItems="center"
//                 mb={2}
//               >
//                 <Typography variant="h5">QR Scan Report</Typography>

//                 <IconButton onClick={fetchReport}>
//                   <RefreshIcon />
//                 </IconButton>
//               </Box>

//               {/* ---------------- Filters ---------------- */}
//               <Box
//                 display="flex"
//                 flexWrap="wrap"
//                 gap={10} // smaller gap for better spacing
//                 mb={3}
//                 alignItems="center"
//               >
//                 <TextField
//                   select
//                   label="Station"
//                   value={station}
//                   onChange={(e) => setStation(e.target.value)}
//                   size="small"
//                   style={{ minWidth: 160, marginRight: 16 }}
//                 >
//                   <MenuItem value="">All</MenuItem>
//                   <MenuItem value="Station1">Station 1</MenuItem>
//                   <MenuItem value="Station2">Station 2</MenuItem>
//                 </TextField>

//                 <TextField
//                   type="date"
//                   label="Start Date"
//                   InputLabelProps={{ shrink: true }}
//                   value={startDate}
//                   onChange={(e) => setStartDate(e.target.value)}
//                   size="small"
//                   style={{ marginRight: 16 }}
//                 />

//                 <TextField
//                   type="date"
//                   label="End Date"
//                   InputLabelProps={{ shrink: true }}
//                   value={endDate}
//                   onChange={(e) => setEndDate(e.target.value)}
//                   size="small"
//                   style={{ marginRight: 16 }}
//                 />

//                 <TextField
//                   label="Invoice Number"
//                   value={invoiceNumber}
//                   onChange={(e) => setInvoiceNumber(e.target.value)}
//                   size="small"
//                   style={{ minWidth: 160, marginRight: 16 }}
//                 />

//                 <Button
//                   variant="contained"
//                   color="primary"
//                   onClick={fetchReport}
//                 >
//                   Apply Filters
//                 </Button>
//               </Box>

//               {/* ---------------- Loader ---------------- */}
//               {loading && (
//                 <Box display="flex" justifyContent="center" my={4}>
//                   <CircularProgress />
//                 </Box>
//               )}

//               {/* ---------------- Table ---------------- */}
//               {!loading && (
//                 <TableContainer component={Paper}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell>#</TableCell>
//                         <TableCell>Invoice No</TableCell>
//                         <TableCell>Station</TableCell>
//                         <TableCell>Scanned By</TableCell>
//                         <TableCell>Status</TableCell>
//                         <TableCell>Reject Reason</TableCell>
//                         <TableCell>Scanned At</TableCell>
//                       </TableRow>
//                     </TableHead>

//                     <TableBody>
//                       {rows.length === 0 && (
//                         <TableRow>
//                           <TableCell colSpan={7} align="center">
//                             No records found
//                           </TableCell>
//                         </TableRow>
//                       )}

//                       {rows.map((row, index) => (
//                         <TableRow key={row._id || index}>
//                           <TableCell>{index + 1}</TableCell>

//                           <TableCell>
//                             {row.invoiceNumber || row.invoiceId?._id || "-"}
//                           </TableCell>

//                           <TableCell>{row.station}</TableCell>

//                           <TableCell>{row.scannedBy?.name || "—"}</TableCell>

//                           <TableCell>
//                             <Typography
//                               style={{
//                                 color:
//                                   row.scanStatus === "SUCCESS"
//                                     ? "green"
//                                     : "red",
//                                 fontWeight: 500,
//                               }}
//                             >
//                               {row.scanStatus}
//                             </Typography>
//                           </TableCell>

//                           <TableCell>{row.rejectReason || "—"}</TableCell>

//                           <TableCell>
//                             {row.scannedAt
//                               ? new Date(row.scannedAt).toLocaleString()
//                               : "—"}
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               )}
//             </CardContent>
//           </Card>
//         </Fade>
//       </Container>
//     </Box>
//   );
// }


// export default function QrScanReport() {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // Filters
//   const [station, setStation] = useState("");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [invoiceNumber, setInvoiceNumber] = useState("");

//   /* ------------------ Fetch Report ------------------ */
//   const fetchReport = async () => {
//     try {
//       setLoading(true);

//       const { data } = await api.fetchQrScanReport({
//         station,
//         startDate,
//         endDate,
//         invoiceNumber,
//       });

//       // ✅ Ensure rows is always an array
//       if (Array.isArray(data)) {
//         setRows(data);
//       } else {
//         setRows([]);
//       }
//     } catch (error) {
//       console.error("Failed to load QR scan report", error);
//       setRows([]); // empty on error
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchReport();
//     // eslint-disable-next-line
//   }, []);

//   return (
//     <Box>
//       <Container maxWidth="lg">
//         <Fade in timeout={600}>
//           <Card>
//             <CardContent>
//               {/* ---------------- Header ---------------- */}
//               <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//                 <Typography variant="h5">QR Scan Report</Typography>
//                 <IconButton onClick={fetchReport}>
//                   <RefreshIcon />
//                 </IconButton>
//               </Box>

//               {/* ---------------- Filters ---------------- */}
//               <Box display="flex" flexWrap="wrap" gap={10} mb={3} alignItems="center">
//                 <TextField
//                   select
//                   label="Station"
//                   value={station}
//                   onChange={(e) => setStation(e.target.value)}
//                   size="small"
//                   style={{ minWidth: 160, marginRight: 16 }}
//                 >
//                   <MenuItem value="">All</MenuItem>
//                   <MenuItem value="Station1">Station 1</MenuItem>
//                   <MenuItem value="Station2">Station 2</MenuItem>
//                 </TextField>

//                 <TextField
//                   type="date"
//                   label="Start Date"
//                   InputLabelProps={{ shrink: true }}
//                   value={startDate}
//                   onChange={(e) => setStartDate(e.target.value)}
//                   size="small"
//                   style={{ marginRight: 16 }}
//                 />

//                 <TextField
//                   type="date"
//                   label="End Date"
//                   InputLabelProps={{ shrink: true }}
//                   value={endDate}
//                   onChange={(e) => setEndDate(e.target.value)}
//                   size="small"
//                   style={{ marginRight: 16 }}
//                 />

//                 <TextField
//                   label="Invoice Number"
//                   value={invoiceNumber}
//                   onChange={(e) => setInvoiceNumber(e.target.value)}
//                   size="small"
//                   style={{ minWidth: 160, marginRight: 16 }}
//                 />

//                 <Button variant="contained" color="primary" onClick={fetchReport}>
//                   Apply Filters
//                 </Button>
//               </Box>

//               {/* ---------------- Loader ---------------- */}
//               {loading && (
//                 <Box display="flex" justifyContent="center" my={4}>
//                   <CircularProgress />
//                 </Box>
//               )}

//               {/* ---------------- Table ---------------- */}
//               {!loading && (
//                 <TableContainer component={Paper}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell>#</TableCell>
//                         <TableCell>Invoice No</TableCell>
//                         <TableCell>Station</TableCell>
//                         <TableCell>Scanned By</TableCell>
//                         <TableCell>Status</TableCell>
//                         <TableCell>Reject Reason</TableCell>
//                         <TableCell>Scanned At</TableCell>
//                       </TableRow>
//                     </TableHead>

//                     <TableBody>
//                       {rows.length === 0 && (
//                         <TableRow>
//                           <TableCell colSpan={7} align="center">
//                             No records found matching your filters
//                           </TableCell>
//                         </TableRow>
//                       )}

//                       {rows.map((row, index) => (
//                         <TableRow key={row._id || index}>
//                           <TableCell>{index + 1}</TableCell>
//                           <TableCell>{row.invoiceNumber || row.invoiceId?._id || "-"}</TableCell>
//                           <TableCell>{row.station}</TableCell>
//                           <TableCell>{row.scannedBy?.name || "—"}</TableCell>
//                           <TableCell>
//                             <Typography
//                               style={{
//                                 color: row.scanStatus === "SUCCESS" ? "green" : "red",
//                                 fontWeight: 500,
//                               }}
//                             >
//                               {row.scanStatus}
//                             </Typography>
//                           </TableCell>
//                           <TableCell>{row.rejectReason || "—"}</TableCell>
//                           <TableCell>{row.scannedAt ? new Date(row.scannedAt).toLocaleString() : "—"}</TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               )}
//             </CardContent>
//           </Card>
//         </Fade>
//       </Container>
//     </Box>
//   );
// }


export default function QrScanReport() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  // Filters
  const [station, setStation] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");

  // Pagination
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;

  /* ------------------ Fetch Report ------------------ */
  const fetchReport = async () => {
    try {
      setLoading(true);
      setPage(0); // reset page on new fetch

      const { data } = await api.fetchQrScanReport({
        station,
        startDate,
        endDate,
        invoiceNumber,
      });

      setRows(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Failed to load QR scan report", error);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
    // eslint-disable-next-line
  }, []);

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  return (
    <Box>
      <Container maxWidth="lg">
        <Fade in timeout={600}>
          <Card>
            <CardContent>
              {/* ---------------- Header ---------------- */}
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h5">QR Scan Report</Typography>
                <IconButton onClick={fetchReport}>
                  <RefreshIcon />
                </IconButton>
              </Box>

              {/* ---------------- Filters ---------------- */}
              <Box display="flex" flexWrap="wrap" gap={10} mb={3} alignItems="center">
                <TextField
                  select
                  label="Station"
                  value={station}
                  onChange={(e) => setStation(e.target.value)}
                  size="small"
                  style={{ minWidth: 160, marginRight: 16 }}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="Station1">Station 1</MenuItem>
                  <MenuItem value="Station2">Station 2</MenuItem>
                </TextField>

                <TextField
                  type="date"
                  label="Start Date"
                  InputLabelProps={{ shrink: true }}
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  size="small"
                  style={{ marginRight: 16 }}
                />

                <TextField
                  type="date"
                  label="End Date"
                  InputLabelProps={{ shrink: true }}
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  size="small"
                  style={{ marginRight: 16 }}
                />

                <TextField
                  label="Invoice Number"
                  value={invoiceNumber}
                  onChange={(e) => setInvoiceNumber(e.target.value)}
                  size="small"
                  style={{ minWidth: 160, marginRight: 16 }}
                />

                <Button variant="contained" color="primary" onClick={fetchReport}>
                  Apply Filters
                </Button>
              </Box>

              {/* ---------------- Loader ---------------- */}
              {loading && (
                <Box display="flex" justifyContent="center" my={4}>
                  <CircularProgress />
                </Box>
              )}

              {/* ---------------- Table ---------------- */}
              {!loading && (
                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>Invoice No</TableCell>
                        <TableCell>Station</TableCell>
                        <TableCell>Scanned By</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Reject Reason</TableCell>
                        <TableCell>Scanned At</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {rows.length === 0 && (
                        <TableRow>
                          <TableCell colSpan={7} align="center">
                            No records found matching your filters
                          </TableCell>
                        </TableRow>
                      )}

                      {rows
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row, index) => (
                          <TableRow key={row._id || index}>
                            <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                            <TableCell>{row.invoiceNumber || row.invoiceId?._id || "-"}</TableCell>
                            <TableCell>{row.station}</TableCell>
                            <TableCell>{row.scannedBy?.name || "—"}</TableCell>
                            <TableCell>
                              <Typography
                                style={{
                                  color: row.scanStatus === "SUCCESS" ? "green" : "red",
                                  fontWeight: 500,
                                }}
                              >
                                {row.scanStatus}
                              </Typography>
                            </TableCell>
                            <TableCell>{row.rejectReason || "—"}</TableCell>
                            <TableCell>
                              {row.scannedAt
                                ? new Date(row.scannedAt).toLocaleString()
                                : "—"}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>

                  {/* ---------------- Pagination ---------------- */}
                  <TablePagination
                    component="div"
                    count={rows.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[10]}
                  />
                </TableContainer>
              )}
            </CardContent>
          </Card>
        </Fade>
      </Container>
    </Box>
  );
}
